import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/Layouts.vue'
import otherRouter from '@/router/modules/others'
import couponRouter from '@/router/modules/coupon'
import { getConsoleVersion } from '@/api/coupon-api.js'

// import store from '@/stores'

Vue.use(Router)

let routes = []

let rootRouter = {
  path: '/',
  component: layout,
  children: [],
  redirect: '/cost/coupon',
}

let redirectRouter = {
  path: '*',
  redirect: '/error',
}

otherRouter(rootRouter.children)
couponRouter(rootRouter.children)

export function createRouter(basePath) {
  const router = new Router({
    mode: 'history',
    base: basePath || '',
    routes: routes.concat([rootRouter, redirectRouter]),
  })
  router.beforeEach(async (to, from, next) => {
    // 判断用户是否有该页面权限

    if (to.meta.isOldVersion || to.meta.isNewVersion) {
      let {
        body: {
          result: { data },
        },
      } = await getConsoleVersion()
      if (to.meta.isOldVersion) {
        if (data === 1) {
          return next('/cost/coupon')
        }
        next()
      }
      if (to.meta.isNewVersion) {
        if (!data) {
          return next('/cost/coupon')
        }
        next()
      }
    }
    next()
  })
  return router
}
